"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Construction = function Construction(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    d: "M3 3.5C3.27614 3.5 3.5 3.27614 3.5 3C3.5 2.72386 3.27614 2.5 3 2.5C2.72386 2.5 2.5 2.72386 2.5 3C2.5 3.27614 2.72386 3.5 3 3.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M5 3.5C5.27614 3.5 5.5 3.27614 5.5 3C5.5 2.72386 5.27614 2.5 5 2.5C4.72386 2.5 4.5 2.72386 4.5 3C4.5 3.27614 4.72386 3.5 5 3.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M7 3.5C7.27614 3.5 7.5 3.27614 7.5 3C7.5 2.72386 7.27614 2.5 7 2.5C6.72386 2.5 6.5 2.72386 6.5 3C6.5 3.27614 6.72386 3.5 7 3.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M9 3.5C9.27614 3.5 9.5 3.27614 9.5 3C9.5 2.72386 9.27614 2.5 9 2.5C8.72386 2.5 8.5 2.72386 8.5 3C8.5 3.27614 8.72386 3.5 9 3.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M11 3.5C11.2761 3.5 11.5 3.27614 11.5 3C11.5 2.72386 11.2761 2.5 11 2.5C10.7239 2.5 10.5 2.72386 10.5 3C10.5 3.27614 10.7239 3.5 11 3.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M13 3.5C13.2761 3.5 13.5 3.27614 13.5 3C13.5 2.72386 13.2761 2.5 13 2.5C12.7239 2.5 12.5 2.72386 12.5 3C12.5 3.27614 12.7239 3.5 13 3.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M15 3.5C15.2761 3.5 15.5 3.27614 15.5 3C15.5 2.72386 15.2761 2.5 15 2.5C14.7239 2.5 14.5 2.72386 14.5 3C14.5 3.27614 14.7239 3.5 15 3.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M17 3.5C17.2761 3.5 17.5 3.27614 17.5 3C17.5 2.72386 17.2761 2.5 17 2.5C16.7239 2.5 16.5 2.72386 16.5 3C16.5 3.27614 16.7239 3.5 17 3.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M19 3.5C19.2761 3.5 19.5 3.27614 19.5 3C19.5 2.72386 19.2761 2.5 19 2.5C18.7239 2.5 18.5 2.72386 18.5 3C18.5 3.27614 18.7239 3.5 19 3.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M3 5.5C3.27614 5.5 3.5 5.27614 3.5 5C3.5 4.72386 3.27614 4.5 3 4.5C2.72386 4.5 2.5 4.72386 2.5 5C2.5 5.27614 2.72386 5.5 3 5.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M15 5.5C15.2761 5.5 15.5 5.27614 15.5 5C15.5 4.72386 15.2761 4.5 15 4.5C14.7239 4.5 14.5 4.72386 14.5 5C14.5 5.27614 14.7239 5.5 15 5.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M17 5.5C17.2761 5.5 17.5 5.27614 17.5 5C17.5 4.72386 17.2761 4.5 17 4.5C16.7239 4.5 16.5 4.72386 16.5 5C16.5 5.27614 16.7239 5.5 17 5.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M19 5.5C19.2761 5.5 19.5 5.27614 19.5 5C19.5 4.72386 19.2761 4.5 19 4.5C18.7239 4.5 18.5 4.72386 18.5 5C18.5 5.27614 18.7239 5.5 19 5.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M3 7.5C3.27614 7.5 3.5 7.27614 3.5 7C3.5 6.72386 3.27614 6.5 3 6.5C2.72386 6.5 2.5 6.72386 2.5 7C2.5 7.27614 2.72386 7.5 3 7.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M15 7.5C15.2761 7.5 15.5 7.27614 15.5 7C15.5 6.72386 15.2761 6.5 15 6.5C14.7239 6.5 14.5 6.72386 14.5 7C14.5 7.27614 14.7239 7.5 15 7.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M17 7.5C17.2761 7.5 17.5 7.27614 17.5 7C17.5 6.72386 17.2761 6.5 17 6.5C16.7239 6.5 16.5 6.72386 16.5 7C16.5 7.27614 16.7239 7.5 17 7.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M19 7.5C19.2761 7.5 19.5 7.27614 19.5 7C19.5 6.72386 19.2761 6.5 19 6.5C18.7239 6.5 18.5 6.72386 18.5 7C18.5 7.27614 18.7239 7.5 19 7.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M3 9.5C3.27614 9.5 3.5 9.27614 3.5 9C3.5 8.72386 3.27614 8.5 3 8.5C2.72386 8.5 2.5 8.72386 2.5 9C2.5 9.27614 2.72386 9.5 3 9.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M15 9.5C15.2761 9.5 15.5 9.27614 15.5 9C15.5 8.72386 15.2761 8.5 15 8.5C14.7239 8.5 14.5 8.72386 14.5 9C14.5 9.27614 14.7239 9.5 15 9.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M17 9.5C17.2761 9.5 17.5 9.27614 17.5 9C17.5 8.72386 17.2761 8.5 17 8.5C16.7239 8.5 16.5 8.72386 16.5 9C16.5 9.27614 16.7239 9.5 17 9.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M19 9.5C19.2761 9.5 19.5 9.27614 19.5 9C19.5 8.72386 19.2761 8.5 19 8.5C18.7239 8.5 18.5 8.72386 18.5 9C18.5 9.27614 18.7239 9.5 19 9.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M3 11.5C3.27614 11.5 3.5 11.2761 3.5 11C3.5 10.7239 3.27614 10.5 3 10.5C2.72386 10.5 2.5 10.7239 2.5 11C2.5 11.2761 2.72386 11.5 3 11.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M15 11.5C15.2761 11.5 15.5 11.2761 15.5 11C15.5 10.7239 15.2761 10.5 15 10.5C14.7239 10.5 14.5 10.7239 14.5 11C14.5 11.2761 14.7239 11.5 15 11.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M17 11.5C17.2761 11.5 17.5 11.2761 17.5 11C17.5 10.7239 17.2761 10.5 17 10.5C16.7239 10.5 16.5 10.7239 16.5 11C16.5 11.2761 16.7239 11.5 17 11.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M19 11.5C19.2761 11.5 19.5 11.2761 19.5 11C19.5 10.7239 19.2761 10.5 19 10.5C18.7239 10.5 18.5 10.7239 18.5 11C18.5 11.2761 18.7239 11.5 19 11.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M3 13.5C3.27614 13.5 3.5 13.2761 3.5 13C3.5 12.7239 3.27614 12.5 3 12.5C2.72386 12.5 2.5 12.7239 2.5 13C2.5 13.2761 2.72386 13.5 3 13.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M15 13.5C15.2761 13.5 15.5 13.2761 15.5 13C15.5 12.7239 15.2761 12.5 15 12.5C14.7239 12.5 14.5 12.7239 14.5 13C14.5 13.2761 14.7239 13.5 15 13.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M13 5.5C13.2761 5.5 13.5 5.27614 13.5 5C13.5 4.72386 13.2761 4.5 13 4.5C12.7239 4.5 12.5 4.72386 12.5 5C12.5 5.27614 12.7239 5.5 13 5.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M13 7.5C13.2761 7.5 13.5 7.27614 13.5 7C13.5 6.72386 13.2761 6.5 13 6.5C12.7239 6.5 12.5 6.72386 12.5 7C12.5 7.27614 12.7239 7.5 13 7.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M13 9.5C13.2761 9.5 13.5 9.27614 13.5 9C13.5 8.72386 13.2761 8.5 13 8.5C12.7239 8.5 12.5 8.72386 12.5 9C12.5 9.27614 12.7239 9.5 13 9.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M13 11.5C13.2761 11.5 13.5 11.2761 13.5 11C13.5 10.7239 13.2761 10.5 13 10.5C12.7239 10.5 12.5 10.7239 12.5 11C12.5 11.2761 12.7239 11.5 13 11.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M13 13.5C13.2761 13.5 13.5 13.2761 13.5 13C13.5 12.7239 13.2761 12.5 13 12.5C12.7239 12.5 12.5 12.7239 12.5 13C12.5 13.2761 12.7239 13.5 13 13.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M11 5.5C11.2761 5.5 11.5 5.27614 11.5 5C11.5 4.72386 11.2761 4.5 11 4.5C10.7239 4.5 10.5 4.72386 10.5 5C10.5 5.27614 10.7239 5.5 11 5.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M11 7.5C11.2761 7.5 11.5 7.27614 11.5 7C11.5 6.72386 11.2761 6.5 11 6.5C10.7239 6.5 10.5 6.72386 10.5 7C10.5 7.27614 10.7239 7.5 11 7.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M11 9.5C11.2761 9.5 11.5 9.27614 11.5 9C11.5 8.72386 11.2761 8.5 11 8.5C10.7239 8.5 10.5 8.72386 10.5 9C10.5 9.27614 10.7239 9.5 11 9.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M11 11.5C11.2761 11.5 11.5 11.2761 11.5 11C11.5 10.7239 11.2761 10.5 11 10.5C10.7239 10.5 10.5 10.7239 10.5 11C10.5 11.2761 10.7239 11.5 11 11.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M11 13.5C11.2761 13.5 11.5 13.2761 11.5 13C11.5 12.7239 11.2761 12.5 11 12.5C10.7239 12.5 10.5 12.7239 10.5 13C10.5 13.2761 10.7239 13.5 11 13.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M9 5.5C9.27614 5.5 9.5 5.27614 9.5 5C9.5 4.72386 9.27614 4.5 9 4.5C8.72386 4.5 8.5 4.72386 8.5 5C8.5 5.27614 8.72386 5.5 9 5.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M9 7.5C9.27614 7.5 9.5 7.27614 9.5 7C9.5 6.72386 9.27614 6.5 9 6.5C8.72386 6.5 8.5 6.72386 8.5 7C8.5 7.27614 8.72386 7.5 9 7.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M9 9.5C9.27614 9.5 9.5 9.27614 9.5 9C9.5 8.72386 9.27614 8.5 9 8.5C8.72386 8.5 8.5 8.72386 8.5 9C8.5 9.27614 8.72386 9.5 9 9.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M9 11.5C9.27614 11.5 9.5 11.2761 9.5 11C9.5 10.7239 9.27614 10.5 9 10.5C8.72386 10.5 8.5 10.7239 8.5 11C8.5 11.2761 8.72386 11.5 9 11.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M9 13.5C9.27614 13.5 9.5 13.2761 9.5 13C9.5 12.7239 9.27614 12.5 9 12.5C8.72386 12.5 8.5 12.7239 8.5 13C8.5 13.2761 8.72386 13.5 9 13.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M7 5.5C7.27614 5.5 7.5 5.27614 7.5 5C7.5 4.72386 7.27614 4.5 7 4.5C6.72386 4.5 6.5 4.72386 6.5 5C6.5 5.27614 6.72386 5.5 7 5.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M7 7.5C7.27614 7.5 7.5 7.27614 7.5 7C7.5 6.72386 7.27614 6.5 7 6.5C6.72386 6.5 6.5 6.72386 6.5 7C6.5 7.27614 6.72386 7.5 7 7.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M7 9.5C7.27614 9.5 7.5 9.27614 7.5 9C7.5 8.72386 7.27614 8.5 7 8.5C6.72386 8.5 6.5 8.72386 6.5 9C6.5 9.27614 6.72386 9.5 7 9.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M7 11.5C7.27614 11.5 7.5 11.2761 7.5 11C7.5 10.7239 7.27614 10.5 7 10.5C6.72386 10.5 6.5 10.7239 6.5 11C6.5 11.2761 6.72386 11.5 7 11.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M7 13.5C7.27614 13.5 7.5 13.2761 7.5 13C7.5 12.7239 7.27614 12.5 7 12.5C6.72386 12.5 6.5 12.7239 6.5 13C6.5 13.2761 6.72386 13.5 7 13.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M5 5.5C5.27614 5.5 5.5 5.27614 5.5 5C5.5 4.72386 5.27614 4.5 5 4.5C4.72386 4.5 4.5 4.72386 4.5 5C4.5 5.27614 4.72386 5.5 5 5.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M5 7.5C5.27614 7.5 5.5 7.27614 5.5 7C5.5 6.72386 5.27614 6.5 5 6.5C4.72386 6.5 4.5 6.72386 4.5 7C4.5 7.27614 4.72386 7.5 5 7.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M5 9.5C5.27614 9.5 5.5 9.27614 5.5 9C5.5 8.72386 5.27614 8.5 5 8.5C4.72386 8.5 4.5 8.72386 4.5 9C4.5 9.27614 4.72386 9.5 5 9.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M5 11.5C5.27614 11.5 5.5 11.2761 5.5 11C5.5 10.7239 5.27614 10.5 5 10.5C4.72386 10.5 4.5 10.7239 4.5 11C4.5 11.2761 4.72386 11.5 5 11.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M5 13.5C5.27614 13.5 5.5 13.2761 5.5 13C5.5 12.7239 5.27614 12.5 5 12.5C4.72386 12.5 4.5 12.7239 4.5 13C4.5 13.2761 4.72386 13.5 5 13.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M17 13.5C17.2761 13.5 17.5 13.2761 17.5 13C17.5 12.7239 17.2761 12.5 17 12.5C16.7239 12.5 16.5 12.7239 16.5 13C16.5 13.2761 16.7239 13.5 17 13.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M19 13.5C19.2761 13.5 19.5 13.2761 19.5 13C19.5 12.7239 19.2761 12.5 19 12.5C18.7239 12.5 18.5 12.7239 18.5 13C18.5 13.2761 18.7239 13.5 19 13.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M3 15.5C3.27614 15.5 3.5 15.2761 3.5 15C3.5 14.7239 3.27614 14.5 3 14.5C2.72386 14.5 2.5 14.7239 2.5 15C2.5 15.2761 2.72386 15.5 3 15.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M5 15.5C5.27614 15.5 5.5 15.2761 5.5 15C5.5 14.7239 5.27614 14.5 5 14.5C4.72386 14.5 4.5 14.7239 4.5 15C4.5 15.2761 4.72386 15.5 5 15.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M7 15.5C7.27614 15.5 7.5 15.2761 7.5 15C7.5 14.7239 7.27614 14.5 7 14.5C6.72386 14.5 6.5 14.7239 6.5 15C6.5 15.2761 6.72386 15.5 7 15.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M9 15.5C9.27614 15.5 9.5 15.2761 9.5 15C9.5 14.7239 9.27614 14.5 9 14.5C8.72386 14.5 8.5 14.7239 8.5 15C8.5 15.2761 8.72386 15.5 9 15.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M11 15.5C11.2761 15.5 11.5 15.2761 11.5 15C11.5 14.7239 11.2761 14.5 11 14.5C10.7239 14.5 10.5 14.7239 10.5 15C10.5 15.2761 10.7239 15.5 11 15.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M13 15.5C13.2761 15.5 13.5 15.2761 13.5 15C13.5 14.7239 13.2761 14.5 13 14.5C12.7239 14.5 12.5 14.7239 12.5 15C12.5 15.2761 12.7239 15.5 13 15.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M15 15.5C15.2761 15.5 15.5 15.2761 15.5 15C15.5 14.7239 15.2761 14.5 15 14.5C14.7239 14.5 14.5 14.7239 14.5 15C14.5 15.2761 14.7239 15.5 15 15.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M17 15.5C17.2761 15.5 17.5 15.2761 17.5 15C17.5 14.7239 17.2761 14.5 17 14.5C16.7239 14.5 16.5 14.7239 16.5 15C16.5 15.2761 16.7239 15.5 17 15.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M19 15.5C19.2761 15.5 19.5 15.2761 19.5 15C19.5 14.7239 19.2761 14.5 19 14.5C18.7239 14.5 18.5 14.7239 18.5 15C18.5 15.2761 18.7239 15.5 19 15.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M3 17.5C3.27614 17.5 3.5 17.2761 3.5 17C3.5 16.7239 3.27614 16.5 3 16.5C2.72386 16.5 2.5 16.7239 2.5 17C2.5 17.2761 2.72386 17.5 3 17.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M5 17.5C5.27614 17.5 5.5 17.2761 5.5 17C5.5 16.7239 5.27614 16.5 5 16.5C4.72386 16.5 4.5 16.7239 4.5 17C4.5 17.2761 4.72386 17.5 5 17.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M7 17.5C7.27614 17.5 7.5 17.2761 7.5 17C7.5 16.7239 7.27614 16.5 7 16.5C6.72386 16.5 6.5 16.7239 6.5 17C6.5 17.2761 6.72386 17.5 7 17.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M9 17.5C9.27614 17.5 9.5 17.2761 9.5 17C9.5 16.7239 9.27614 16.5 9 16.5C8.72386 16.5 8.5 16.7239 8.5 17C8.5 17.2761 8.72386 17.5 9 17.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M11 17.5C11.2761 17.5 11.5 17.2761 11.5 17C11.5 16.7239 11.2761 16.5 11 16.5C10.7239 16.5 10.5 16.7239 10.5 17C10.5 17.2761 10.7239 17.5 11 17.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M13 17.5C13.2761 17.5 13.5 17.2761 13.5 17C13.5 16.7239 13.2761 16.5 13 16.5C12.7239 16.5 12.5 16.7239 12.5 17C12.5 17.2761 12.7239 17.5 13 17.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M15 17.5C15.2761 17.5 15.5 17.2761 15.5 17C15.5 16.7239 15.2761 16.5 15 16.5C14.7239 16.5 14.5 16.7239 14.5 17C14.5 17.2761 14.7239 17.5 15 17.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M17 17.5C17.2761 17.5 17.5 17.2761 17.5 17C17.5 16.7239 17.2761 16.5 17 16.5C16.7239 16.5 16.5 16.7239 16.5 17C16.5 17.2761 16.7239 17.5 17 17.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M19 17.5C19.2761 17.5 19.5 17.2761 19.5 17C19.5 16.7239 19.2761 16.5 19 16.5C18.7239 16.5 18.5 16.7239 18.5 17C18.5 17.2761 18.7239 17.5 19 17.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M3 19.5C3.27614 19.5 3.5 19.2761 3.5 19C3.5 18.7239 3.27614 18.5 3 18.5C2.72386 18.5 2.5 18.7239 2.5 19C2.5 19.2761 2.72386 19.5 3 19.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M5 19.5C5.27614 19.5 5.5 19.2761 5.5 19C5.5 18.7239 5.27614 18.5 5 18.5C4.72386 18.5 4.5 18.7239 4.5 19C4.5 19.2761 4.72386 19.5 5 19.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M7 19.5C7.27614 19.5 7.5 19.2761 7.5 19C7.5 18.7239 7.27614 18.5 7 18.5C6.72386 18.5 6.5 18.7239 6.5 19C6.5 19.2761 6.72386 19.5 7 19.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M9 19.5C9.27614 19.5 9.5 19.2761 9.5 19C9.5 18.7239 9.27614 18.5 9 18.5C8.72386 18.5 8.5 18.7239 8.5 19C8.5 19.2761 8.72386 19.5 9 19.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M11 19.5C11.2761 19.5 11.5 19.2761 11.5 19C11.5 18.7239 11.2761 18.5 11 18.5C10.7239 18.5 10.5 18.7239 10.5 19C10.5 19.2761 10.7239 19.5 11 19.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M13 19.5C13.2761 19.5 13.5 19.2761 13.5 19C13.5 18.7239 13.2761 18.5 13 18.5C12.7239 18.5 12.5 18.7239 12.5 19C12.5 19.2761 12.7239 19.5 13 19.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M15 19.5C15.2761 19.5 15.5 19.2761 15.5 19C15.5 18.7239 15.2761 18.5 15 18.5C14.7239 18.5 14.5 18.7239 14.5 19C14.5 19.2761 14.7239 19.5 15 19.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M17 19.5C17.2761 19.5 17.5 19.2761 17.5 19C17.5 18.7239 17.2761 18.5 17 18.5C16.7239 18.5 16.5 18.7239 16.5 19C16.5 19.2761 16.7239 19.5 17 19.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M19 19.5C19.2761 19.5 19.5 19.2761 19.5 19C19.5 18.7239 19.2761 18.5 19 18.5C18.7239 18.5 18.5 18.7239 18.5 19C18.5 19.2761 18.7239 19.5 19 19.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M21 3.5C21.2761 3.5 21.5 3.27614 21.5 3C21.5 2.72386 21.2761 2.5 21 2.5C20.7239 2.5 20.5 2.72386 20.5 3C20.5 3.27614 20.7239 3.5 21 3.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M21 5.5C21.2761 5.5 21.5 5.27614 21.5 5C21.5 4.72386 21.2761 4.5 21 4.5C20.7239 4.5 20.5 4.72386 20.5 5C20.5 5.27614 20.7239 5.5 21 5.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M21 7.5C21.2761 7.5 21.5 7.27614 21.5 7C21.5 6.72386 21.2761 6.5 21 6.5C20.7239 6.5 20.5 6.72386 20.5 7C20.5 7.27614 20.7239 7.5 21 7.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M21 9.5C21.2761 9.5 21.5 9.27614 21.5 9C21.5 8.72386 21.2761 8.5 21 8.5C20.7239 8.5 20.5 8.72386 20.5 9C20.5 9.27614 20.7239 9.5 21 9.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M21 11.5C21.2761 11.5 21.5 11.2761 21.5 11C21.5 10.7239 21.2761 10.5 21 10.5C20.7239 10.5 20.5 10.7239 20.5 11C20.5 11.2761 20.7239 11.5 21 11.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M21 13.5C21.2761 13.5 21.5 13.2761 21.5 13C21.5 12.7239 21.2761 12.5 21 12.5C20.7239 12.5 20.5 12.7239 20.5 13C20.5 13.2761 20.7239 13.5 21 13.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M21 15.5C21.2761 15.5 21.5 15.2761 21.5 15C21.5 14.7239 21.2761 14.5 21 14.5C20.7239 14.5 20.5 14.7239 20.5 15C20.5 15.2761 20.7239 15.5 21 15.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M21 17.5C21.2761 17.5 21.5 17.2761 21.5 17C21.5 16.7239 21.2761 16.5 21 16.5C20.7239 16.5 20.5 16.7239 20.5 17C20.5 17.2761 20.7239 17.5 21 17.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M21 19.5C21.2761 19.5 21.5 19.2761 21.5 19C21.5 18.7239 21.2761 18.5 21 18.5C20.7239 18.5 20.5 18.7239 20.5 19C20.5 19.2761 20.7239 19.5 21 19.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M3 21.5C3.27614 21.5 3.5 21.2761 3.5 21C3.5 20.7239 3.27614 20.5 3 20.5C2.72386 20.5 2.5 20.7239 2.5 21C2.5 21.2761 2.72386 21.5 3 21.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M5 21.5C5.27614 21.5 5.5 21.2761 5.5 21C5.5 20.7239 5.27614 20.5 5 20.5C4.72386 20.5 4.5 20.7239 4.5 21C4.5 21.2761 4.72386 21.5 5 21.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M7 21.5C7.27614 21.5 7.5 21.2761 7.5 21C7.5 20.7239 7.27614 20.5 7 20.5C6.72386 20.5 6.5 20.7239 6.5 21C6.5 21.2761 6.72386 21.5 7 21.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M9 21.5C9.27614 21.5 9.5 21.2761 9.5 21C9.5 20.7239 9.27614 20.5 9 20.5C8.72386 20.5 8.5 20.7239 8.5 21C8.5 21.2761 8.72386 21.5 9 21.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M11 21.5C11.2761 21.5 11.5 21.2761 11.5 21C11.5 20.7239 11.2761 20.5 11 20.5C10.7239 20.5 10.5 20.7239 10.5 21C10.5 21.2761 10.7239 21.5 11 21.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M13 21.5C13.2761 21.5 13.5 21.2761 13.5 21C13.5 20.7239 13.2761 20.5 13 20.5C12.7239 20.5 12.5 20.7239 12.5 21C12.5 21.2761 12.7239 21.5 13 21.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M15 21.5C15.2761 21.5 15.5 21.2761 15.5 21C15.5 20.7239 15.2761 20.5 15 20.5C14.7239 20.5 14.5 20.7239 14.5 21C14.5 21.2761 14.7239 21.5 15 21.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M17 21.5C17.2761 21.5 17.5 21.2761 17.5 21C17.5 20.7239 17.2761 20.5 17 20.5C16.7239 20.5 16.5 20.7239 16.5 21C16.5 21.2761 16.7239 21.5 17 21.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M19 21.5C19.2761 21.5 19.5 21.2761 19.5 21C19.5 20.7239 19.2761 20.5 19 20.5C18.7239 20.5 18.5 20.7239 18.5 21C18.5 21.2761 18.7239 21.5 19 21.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M21 21.5C21.2761 21.5 21.5 21.2761 21.5 21C21.5 20.7239 21.2761 20.5 21 20.5C20.7239 20.5 20.5 20.7239 20.5 21C20.5 21.2761 20.7239 21.5 21 21.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M3 1.5C3.27614 1.5 3.5 1.27614 3.5 1C3.5 0.723858 3.27614 0.5 3 0.5C2.72386 0.5 2.5 0.723858 2.5 1C2.5 1.27614 2.72386 1.5 3 1.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M5 1.5C5.27614 1.5 5.5 1.27614 5.5 1C5.5 0.723858 5.27614 0.5 5 0.5C4.72386 0.5 4.5 0.723858 4.5 1C4.5 1.27614 4.72386 1.5 5 1.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M7 1.5C7.27614 1.5 7.5 1.27614 7.5 1C7.5 0.723858 7.27614 0.5 7 0.5C6.72386 0.5 6.5 0.723858 6.5 1C6.5 1.27614 6.72386 1.5 7 1.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M9 1.5C9.27614 1.5 9.5 1.27614 9.5 1C9.5 0.723858 9.27614 0.5 9 0.5C8.72386 0.5 8.5 0.723858 8.5 1C8.5 1.27614 8.72386 1.5 9 1.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M11 1.5C11.2761 1.5 11.5 1.27614 11.5 1C11.5 0.723858 11.2761 0.5 11 0.5C10.7239 0.5 10.5 0.723858 10.5 1C10.5 1.27614 10.7239 1.5 11 1.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M13 1.5C13.2761 1.5 13.5 1.27614 13.5 1C13.5 0.723858 13.2761 0.5 13 0.5C12.7239 0.5 12.5 0.723858 12.5 1C12.5 1.27614 12.7239 1.5 13 1.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M15 1.5C15.2761 1.5 15.5 1.27614 15.5 1C15.5 0.723858 15.2761 0.5 15 0.5C14.7239 0.5 14.5 0.723858 14.5 1C14.5 1.27614 14.7239 1.5 15 1.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M17 1.5C17.2761 1.5 17.5 1.27614 17.5 1C17.5 0.723858 17.2761 0.5 17 0.5C16.7239 0.5 16.5 0.723858 16.5 1C16.5 1.27614 16.7239 1.5 17 1.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M19 1.5C19.2761 1.5 19.5 1.27614 19.5 1C19.5 0.723858 19.2761 0.5 19 0.5C18.7239 0.5 18.5 0.723858 18.5 1C18.5 1.27614 18.7239 1.5 19 1.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M21 1.5C21.2761 1.5 21.5 1.27614 21.5 1C21.5 0.723858 21.2761 0.5 21 0.5C20.7239 0.5 20.5 0.723858 20.5 1C20.5 1.27614 20.7239 1.5 21 1.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M3 23.5C3.27614 23.5 3.5 23.2761 3.5 23C3.5 22.7239 3.27614 22.5 3 22.5C2.72386 22.5 2.5 22.7239 2.5 23C2.5 23.2761 2.72386 23.5 3 23.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M5 23.5C5.27614 23.5 5.5 23.2761 5.5 23C5.5 22.7239 5.27614 22.5 5 22.5C4.72386 22.5 4.5 22.7239 4.5 23C4.5 23.2761 4.72386 23.5 5 23.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M7 23.5C7.27614 23.5 7.5 23.2761 7.5 23C7.5 22.7239 7.27614 22.5 7 22.5C6.72386 22.5 6.5 22.7239 6.5 23C6.5 23.2761 6.72386 23.5 7 23.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M9 23.5C9.27614 23.5 9.5 23.2761 9.5 23C9.5 22.7239 9.27614 22.5 9 22.5C8.72386 22.5 8.5 22.7239 8.5 23C8.5 23.2761 8.72386 23.5 9 23.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M11 23.5C11.2761 23.5 11.5 23.2761 11.5 23C11.5 22.7239 11.2761 22.5 11 22.5C10.7239 22.5 10.5 22.7239 10.5 23C10.5 23.2761 10.7239 23.5 11 23.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M13 23.5C13.2761 23.5 13.5 23.2761 13.5 23C13.5 22.7239 13.2761 22.5 13 22.5C12.7239 22.5 12.5 22.7239 12.5 23C12.5 23.2761 12.7239 23.5 13 23.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M15 23.5C15.2761 23.5 15.5 23.2761 15.5 23C15.5 22.7239 15.2761 22.5 15 22.5C14.7239 22.5 14.5 22.7239 14.5 23C14.5 23.2761 14.7239 23.5 15 23.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M17 23.5C17.2761 23.5 17.5 23.2761 17.5 23C17.5 22.7239 17.2761 22.5 17 22.5C16.7239 22.5 16.5 22.7239 16.5 23C16.5 23.2761 16.7239 23.5 17 23.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M19 23.5C19.2761 23.5 19.5 23.2761 19.5 23C19.5 22.7239 19.2761 22.5 19 22.5C18.7239 22.5 18.5 22.7239 18.5 23C18.5 23.2761 18.7239 23.5 19 23.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M21 23.5C21.2761 23.5 21.5 23.2761 21.5 23C21.5 22.7239 21.2761 22.5 21 22.5C20.7239 22.5 20.5 22.7239 20.5 23C20.5 23.2761 20.7239 23.5 21 23.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M23 3.5C23.2761 3.5 23.5 3.27614 23.5 3C23.5 2.72386 23.2761 2.5 23 2.5C22.7239 2.5 22.5 2.72386 22.5 3C22.5 3.27614 22.7239 3.5 23 3.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M23 5.5C23.2761 5.5 23.5 5.27614 23.5 5C23.5 4.72386 23.2761 4.5 23 4.5C22.7239 4.5 22.5 4.72386 22.5 5C22.5 5.27614 22.7239 5.5 23 5.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M23 7.5C23.2761 7.5 23.5 7.27614 23.5 7C23.5 6.72386 23.2761 6.5 23 6.5C22.7239 6.5 22.5 6.72386 22.5 7C22.5 7.27614 22.7239 7.5 23 7.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M23 9.5C23.2761 9.5 23.5 9.27614 23.5 9C23.5 8.72386 23.2761 8.5 23 8.5C22.7239 8.5 22.5 8.72386 22.5 9C22.5 9.27614 22.7239 9.5 23 9.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M23 11.5C23.2761 11.5 23.5 11.2761 23.5 11C23.5 10.7239 23.2761 10.5 23 10.5C22.7239 10.5 22.5 10.7239 22.5 11C22.5 11.2761 22.7239 11.5 23 11.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M23 13.5C23.2761 13.5 23.5 13.2761 23.5 13C23.5 12.7239 23.2761 12.5 23 12.5C22.7239 12.5 22.5 12.7239 22.5 13C22.5 13.2761 22.7239 13.5 23 13.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M23 15.5C23.2761 15.5 23.5 15.2761 23.5 15C23.5 14.7239 23.2761 14.5 23 14.5C22.7239 14.5 22.5 14.7239 22.5 15C22.5 15.2761 22.7239 15.5 23 15.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M23 17.5C23.2761 17.5 23.5 17.2761 23.5 17C23.5 16.7239 23.2761 16.5 23 16.5C22.7239 16.5 22.5 16.7239 22.5 17C22.5 17.2761 22.7239 17.5 23 17.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M23 19.5C23.2761 19.5 23.5 19.2761 23.5 19C23.5 18.7239 23.2761 18.5 23 18.5C22.7239 18.5 22.5 18.7239 22.5 19C22.5 19.2761 22.7239 19.5 23 19.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M23 21.5C23.2761 21.5 23.5 21.2761 23.5 21C23.5 20.7239 23.2761 20.5 23 20.5C22.7239 20.5 22.5 20.7239 22.5 21C22.5 21.2761 22.7239 21.5 23 21.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M1 3.5C1.27614 3.5 1.5 3.27614 1.5 3C1.5 2.72386 1.27614 2.5 1 2.5C0.723858 2.5 0.5 2.72386 0.5 3C0.5 3.27614 0.723858 3.5 1 3.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M1 5.5C1.27614 5.5 1.5 5.27614 1.5 5C1.5 4.72386 1.27614 4.5 1 4.5C0.723858 4.5 0.5 4.72386 0.5 5C0.5 5.27614 0.723858 5.5 1 5.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M1 7.5C1.27614 7.5 1.5 7.27614 1.5 7C1.5 6.72386 1.27614 6.5 1 6.5C0.723858 6.5 0.5 6.72386 0.5 7C0.5 7.27614 0.723858 7.5 1 7.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M1 9.5C1.27614 9.5 1.5 9.27614 1.5 9C1.5 8.72386 1.27614 8.5 1 8.5C0.723858 8.5 0.5 8.72386 0.5 9C0.5 9.27614 0.723858 9.5 1 9.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M1 11.5C1.27614 11.5 1.5 11.2761 1.5 11C1.5 10.7239 1.27614 10.5 1 10.5C0.723858 10.5 0.5 10.7239 0.5 11C0.5 11.2761 0.723858 11.5 1 11.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M1 13.5C1.27614 13.5 1.5 13.2761 1.5 13C1.5 12.7239 1.27614 12.5 1 12.5C0.723858 12.5 0.5 12.7239 0.5 13C0.5 13.2761 0.723858 13.5 1 13.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M1 15.5C1.27614 15.5 1.5 15.2761 1.5 15C1.5 14.7239 1.27614 14.5 1 14.5C0.723858 14.5 0.5 14.7239 0.5 15C0.5 15.2761 0.723858 15.5 1 15.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M1 17.5C1.27614 17.5 1.5 17.2761 1.5 17C1.5 16.7239 1.27614 16.5 1 16.5C0.723858 16.5 0.5 16.7239 0.5 17C0.5 17.2761 0.723858 17.5 1 17.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M1 19.5C1.27614 19.5 1.5 19.2761 1.5 19C1.5 18.7239 1.27614 18.5 1 18.5C0.723858 18.5 0.5 18.7239 0.5 19C0.5 19.2761 0.723858 19.5 1 19.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M1 21.5C1.27614 21.5 1.5 21.2761 1.5 21C1.5 20.7239 1.27614 20.5 1 20.5C0.723858 20.5 0.5 20.7239 0.5 21C0.5 21.2761 0.723858 21.5 1 21.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M1 1.5C1.27614 1.5 1.5 1.27614 1.5 1C1.5 0.723858 1.27614 0.5 1 0.5C0.723858 0.5 0.5 0.723858 0.5 1C0.5 1.27614 0.723858 1.5 1 1.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M1 23.5C1.27614 23.5 1.5 23.2761 1.5 23C1.5 22.7239 1.27614 22.5 1 22.5C0.723858 22.5 0.5 22.7239 0.5 23C0.5 23.2761 0.723858 23.5 1 23.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M23 1.5C23.2761 1.5 23.5 1.27614 23.5 1C23.5 0.723858 23.2761 0.5 23 0.5C22.7239 0.5 22.5 0.723858 22.5 1C22.5 1.27614 22.7239 1.5 23 1.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M23 23.5C23.2761 23.5 23.5 23.2761 23.5 23C23.5 22.7239 23.2761 22.5 23 22.5C22.7239 22.5 22.5 22.7239 22.5 23C22.5 23.2761 22.7239 23.5 23 23.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M12 15.5C12.6922 15.5 13.3689 15.2947 13.9445 14.9101C14.5201 14.5256 14.9687 13.9789 15.2336 13.3394C15.4985 12.6999 15.5678 11.9961 15.4327 11.3172C15.2977 10.6383 14.9644 10.0146 14.4749 9.52513C13.9854 9.03564 13.3618 8.7023 12.6828 8.56725C12.0039 8.4322 11.3001 8.50152 10.6606 8.76642C10.0211 9.03133 9.47444 9.47993 9.08986 10.0555C8.70527 10.6311 8.5 11.3078 8.5 12C8.50104 12.9279 8.87013 13.8176 9.52628 14.4737C10.1824 15.1299 11.0721 15.499 12 15.5ZM12 9.5C12.4945 9.5 12.9778 9.64662 13.3889 9.92133C13.8 10.196 14.1205 10.5865 14.3097 11.0433C14.4989 11.5001 14.5484 12.0028 14.452 12.4877C14.3555 12.9727 14.1174 13.4181 13.7678 13.7678C13.4181 14.1174 12.9727 14.3555 12.4877 14.452C12.0028 14.5484 11.5001 14.4989 11.0433 14.3097C10.5865 14.1205 10.196 13.8 9.92133 13.3889C9.64662 12.9778 9.5 12.4945 9.5 12C9.50074 11.3372 9.76436 10.7017 10.233 10.233C10.7017 9.76436 11.3372 9.50074 12 9.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M19.5 9C19.5 8.86739 19.4473 8.74021 19.3536 8.64645C19.2598 8.55268 19.1326 8.5 19 8.5C18.8674 8.5 18.7402 8.55268 18.6464 8.64645C18.5527 8.74021 18.5 8.86739 18.5 9V11.5H17.4701C17.1818 8.69444 14.8387 6.5 12 6.5C10.1346 6.5 8.48333 7.44786 7.48844 8.89381C7.4642 8.78227 7.40253 8.68239 7.31368 8.61075C7.22483 8.53912 7.11414 8.50003 7 8.5H3C2.86739 8.5 2.74021 8.55268 2.64645 8.64645C2.55268 8.74021 2.5 8.86739 2.5 9V15C2.5 15.1326 2.55268 15.2598 2.64645 15.3536C2.74021 15.4473 2.86739 15.5 3 15.5H6.5V18.5503C6.05751 18.6407 5.64776 18.8492 5.31429 19.1538C4.98083 19.4584 4.7361 19.8476 4.60611 20.2801C4.47612 20.7127 4.46573 21.1723 4.57603 21.6103C4.68633 22.0482 4.91321 22.4481 5.23256 22.7675C5.55192 23.0868 5.95181 23.3137 6.38977 23.424C6.82773 23.5343 7.28738 23.5239 7.7199 23.3939C8.15242 23.2639 8.54165 23.0192 8.84623 22.6857C9.15081 22.3522 9.35937 21.9425 9.44975 21.5H16.5V23C16.5 23.1326 16.5527 23.2598 16.6464 23.3536C16.7402 23.4473 16.8674 23.5 17 23.5C17.1326 23.5 17.2598 23.4473 17.3536 23.3536C17.4473 23.2598 17.5 23.1326 17.5 23V12.5H18.5V15C18.5 15.1326 18.5527 15.2598 18.6464 15.3536C18.7402 15.4473 18.8674 15.5 19 15.5C19.1326 15.5 19.2598 15.4473 19.3536 15.3536C19.4473 15.2598 19.5 15.1326 19.5 15V9ZM12 7.5C14.4813 7.5 16.5 9.55608 16.5 12.0833C16.5 14.6106 14.4813 16.6667 12 16.6667C9.51869 16.6667 7.5 14.6106 7.5 12.0833C7.5 9.55608 9.51869 7.5 12 7.5ZM3.5 14.5V9.5H6.5V14.5H3.5ZM7 22.5C6.70333 22.5 6.41332 22.412 6.16664 22.2472C5.91997 22.0824 5.72771 21.8481 5.61418 21.574C5.50065 21.2999 5.47094 20.9983 5.52882 20.7074C5.5867 20.4164 5.72956 20.1491 5.93934 19.9393C6.14912 19.7296 6.41639 19.5867 6.70736 19.5288C6.99834 19.4709 7.29994 19.5007 7.57403 19.6142C7.84811 19.7277 8.08238 19.92 8.2472 20.1666C8.41203 20.4133 8.5 20.7033 8.5 21C8.49955 21.3977 8.34137 21.779 8.06016 22.0602C7.77896 22.3414 7.39769 22.4996 7 22.5ZM9.44975 20.5C9.35083 20.02 9.11344 19.5796 8.76693 19.2331C8.42041 18.8866 7.97996 18.6492 7.5 18.5503V15.2898C8.49617 16.7262 10.1418 17.6667 12 17.6667C13.8582 17.6667 15.5038 16.7262 16.5 15.2898V20.5H9.44975Z",
    fill: props.foregroundColor
  }));
};

Construction.defaultProps = {
  altText: "Construction",
  backgroundColor: "#FFFFFF",
  foregroundColor: "#212121"
};
Construction.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Construction;
exports.default = _default;